import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatMXN } from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export default function ProductoDetail() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [size, setSize] = useState("");
  const [color, setColor] = useState("");
  const [qty, setQty] = useState(1);
  const [active, setActive] = useState(0);
  const { addItem } = useCart();

  useEffect(() => {
    api.get(`/products/${slug}`).then(({ data }) => {
      setProduct(data);
      setSize(data.sizes?.[0] || "");
      setColor(data.colors?.[0] || "");
    });
  }, [slug]);

  if (!product) return <div className="mx-auto max-w-7xl px-6 py-24">Cargando…</div>;

  const onAdd = () => {
    if (product.sizes?.length && !size) return toast.error("Elige una talla");
    addItem(product, { qty, size, color });
    toast.success("Añadido a la bolsa");
  };

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-12 py-12 grid lg:grid-cols-12 gap-12" data-testid="producto-page">
      <div className="lg:col-span-7">
        <div className="aspect-[4/5] bg-[#F2EFE9] overflow-hidden">
          <img src={product.images?.[active]} alt={product.name} className="h-full w-full object-cover" />
        </div>
        {product.images?.length > 1 && (
          <div className="mt-4 grid grid-cols-5 gap-2">
            {product.images.map((img, i) => (
              <button key={i} onClick={() => setActive(i)} className={`aspect-square overflow-hidden border ${i === active ? "border-[#A94438]" : "border-transparent"}`}>
                <img src={img} alt="" className="h-full w-full object-cover" />
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="lg:col-span-5 lg:pt-8">
        <Link to={`/catalogo/${product.category_slug}`} className="text-xs uppercase tracking-[0.3em] text-[#A94438] link-underline">{product.category_slug}</Link>
        <h1 className="mt-3 font-serif text-5xl tracking-tighter leading-tight">{product.name}</h1>
        <div className="mt-4 flex items-baseline gap-3">
          <span className="text-xl">{formatMXN(product.price)}</span>
          {product.compare_price && product.compare_price > product.price && (
            <span className="text-sm text-[#5B605E] line-through">{formatMXN(product.compare_price)}</span>
          )}
        </div>
        <p className="mt-6 text-[#5B605E] leading-relaxed">{product.description}</p>

        {product.sizes?.length > 0 && (
          <div className="mt-8">
            <p className="text-xs uppercase tracking-wider mb-2">Talla</p>
            <div className="flex flex-wrap gap-2">
              {product.sizes.map((s) => (
                <button key={s} onClick={() => setSize(s)} data-testid={`size-${s}`} className={`px-4 py-2 text-xs border ${size === s ? "bg-[#2C302E] text-[#F9F6F0]" : "border-[#2C302E]"}`}>{s}</button>
              ))}
            </div>
          </div>
        )}

        {product.colors?.length > 0 && (
          <div className="mt-6">
            <p className="text-xs uppercase tracking-wider mb-2">Color</p>
            <div className="flex flex-wrap gap-2">
              {product.colors.map((c) => (
                <button key={c} onClick={() => setColor(c)} className={`px-4 py-2 text-xs border ${color === c ? "bg-[#2C302E] text-[#F9F6F0]" : "border-[#2C302E]"}`}>{c}</button>
              ))}
            </div>
          </div>
        )}

        <div className="mt-8 flex gap-4">
          <div className="flex items-center border border-[#2C302E]">
            <button onClick={() => setQty(Math.max(1, qty - 1))} className="px-4 py-3">−</button>
            <span className="px-4 text-sm" data-testid="qty">{qty}</span>
            <button onClick={() => setQty(qty + 1)} className="px-4 py-3">+</button>
          </div>
          <button onClick={onAdd} data-testid="add-to-cart-btn" className="btn-primary flex-1">Añadir a la bolsa</button>
        </div>

        <div className="mt-10 border-t border-[#E8E3DA] pt-6 text-sm space-y-2 text-[#5B605E]">
          <p>· Envío gratis en compras mayores a $999</p>
          <p>· Cambios y devoluciones dentro de 14 días</p>
          <p>· Empaque de regalo disponible</p>
        </div>
      </div>
    </div>
  );
}
